import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { LoadIncidents, LoadIncident } from '../states/incidents/incidents.actions';
import { mapRouteParamsToIncidentsFilters } from '@app/utils/incidents/incidents.utils';

@Injectable({
  providedIn: 'root',
})
export class IncidentsResolver implements Resolve<boolean> {
  constructor(private store: Store) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<boolean> {
    // Either resolve a single incident if incident Id is provided in the URL params
    const incidentId = route.paramMap.get('incidentId');
    if (incidentId) {
      this.store.dispatch(new LoadIncident({ incidentId }));
      return true;
    }

    // or load multiple incidents filtered by the filters in the URL params
    const { filters, pageNumber, pageSize, sortBy, sortDirection } = mapRouteParamsToIncidentsFilters(
      route.queryParams,
    );

    this.store.dispatch(new LoadIncidents({ filters, pageNumber, pageSize, sortBy, sortDirection }));

    return true;
  }
}
